import React, { useEffect } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import "../../../styles/globals.css";
import "./UnsubscribeDonePage.css";

/**
 * 退会手続き完了画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function UnsubscribeDonePage() {
  /**
   * コンポーネントがマウントされた時
   */
  useEffect(() => {}, []);

  return (
    <div className="unsubscribe-done">
      <div className="main-area">
        <div className="done-message-area">
          <CheckCircleOutlined className="done-message-icon" />
          <div className="done-message-label">退会手続きが完了いたしました</div>
        </div>
        <div className="done-message-detail">
          ご利用ありがとうございました。
          <br />
          またのご利用がございましたら、
          <br />
          再度会員登録をお願いいたします。
          <br />
          これまでご利用いただき、
          <br />
          誠にありがとうございました。
        </div>
      </div>
    </div>
  );
}

export default UnsubscribeDonePage;
